export interface MaintenanceLookup {
  id: string;
  name: string;
  sort_order: number;
  is_active: boolean;
  created_at?: string;
}

export interface MaintenanceInvoice {
  id: string;
  vehicle_number: string | null;
  file_path: string | null;
  file_name: string | null;
  supplier: string | null;
  invoice_number: string | null;
  invoice_date: string | null;
  total_amount: number | null;
  gst_amount: number | null;
  ai_summary: any;
  created_at?: string;
}

export interface MaintenanceRecord {
  id: string;
  vehicle_number: string;
  system_name: string | null;
  work_type_name: string | null;
  service_date: string;
  cost: number | null;
  is_labour: boolean;
  is_gst?: boolean | null;
  odometer: number | null;
  supplier: string | null;
  notes: string | null;
  invoice_id: string | null;
  created_at?: string;
}

export interface AiLineItem {
  description: string;
  source_text?: string;
  amount: number;
  is_labour: boolean;
  suggested_system: string;
  suggested_work_type: string;
}

export interface AiInvoiceResult {
  supplier: string | null;
  registration?: string | null;
  invoice_number: string | null;
  invoice_date: string | null;
  total_amount: number | null;
  gst_amount?: number | null;
  subtotal?: number | null;
  line_items: AiLineItem[];
}


export function money(v: number | null | undefined): string {
  if (v == null || isNaN(Number(v))) return "-";
  return `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
